/**
 * GA4 measurement ID check (build-time env: VITE_GA_MEASUREMENT_ID).
 * Used by Admin → Integrations to show whether public-site tracking is configured.
 */
const GA4_ID_PATTERN = /^G-[A-Z0-9]+$/i;

export function isGa4MeasurementIdConfigured(measurementId: string | undefined): boolean {
  if (measurementId == null || typeof measurementId !== 'string') return false;
  return GA4_ID_PATTERN.test(measurementId.trim());
}
